import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { USER_TYPES } from '../shared/constants';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    const user = this.authService.getUser();
    
    if (user) {
      // Verificar si el usuario es administrativo por type.name
      if (user.type && user.type.id === USER_TYPES.Administrator.id) {
        return true;
      }
      
      // O verificar si tiene el rol en el array de roles
      if (user.roles && Array.isArray(user.roles) && user.roles.length > 0) {
        const isAdmin = user.roles.some(role => 
          typeof role === 'object' && role.name === 'Administrativo'
        );
        
        if (isAdmin) {
          return true;
        }
      }
    }
    
    this.router.navigate(['/dashboard']);
    return false;
  }
} 